import { useEffect, useCallback, useContext } from "react";
import useReduxState from "./useReduxState";
import { ImessageObject } from "@api/types/chat";
import { SocketContext } from "@context/socket";
import { useLazyQuery } from "@apollo/react-hooks";
import { toastErrorMessage } from "@utils/utils";
import { GET_MESSAGES } from "@graphql/Mutations";

export default function useChatEventHandler() {
  const [{ messages }, setChats] = useReduxState((state) => state.chat);

  const [fetchMessages] = useLazyQuery(GET_MESSAGES, {
    onCompleted: (data) => {
      updateChatMessages(data.getMessages.messages);
    },
    onError: (e) => toastErrorMessage(e.message),
  });

  const socket = useContext(SocketContext);

  const addChatMessage = useCallback(
    (message: ImessageObject) => {
      setChats({
        type: "ADD_CHAT_MESSAGE",
        arg: message,
      });
    },
    [messages]
  );

  const updateChatMessages = useCallback(
    (newMessages: ImessageObject[]) => {
      setChats({
        type: "SET_CHAT_DATA",
        arg: {
          messages: newMessages,
        },
      });
    },
    [messages]
  );

  useEffect(() => {
    (async () => {
      if (messages.length === 0) {
        await fetchMessages();
      }
    })();
  }, []);

  useEffect(() => {
    socket.emit("chat");
    socket.on("message", (message) => {
      addChatMessage(message);
    });
    socket.on("like", ({ userId, messageId }) => {
      setChats({
        type: "LIKE_CHAT_MESSAGE",
        arg: {
          userId,
          messageId,
        },
      });
    });
    socket.on("unlike", ({ userId, messageId }) => {
      setChats({
        type: "UNLIKE_CHAT_MESSAGE",
        arg: {
          userId,
          messageId,
        },
      });
    });

    socket.on("users", ({ players }) => {
      setChats({
        type: "SET_NUMBER_OF_USERS",
        arg: {
          players,
        },
      });
    });
  }, []);
}
